import React from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import moment from 'moment';

import { TourRequestState } from '../../src/__generated__/bffGlobalTypes';
import type { BuyerAppointments } from '../graphql/queries/__generated__/BuyerAppointments';

type BuyerAppointments_buyerAppointments = BuyerAppointments['buyerAppointments'][number];
import { formatPhoneNumberInput } from '../helpers/formatUtils';
import { capitalCase } from '../helpers/string';
import { ContentCard } from './ContentCard';
import StatusBadge, { BadgeColor } from './StatusBadge';

interface IBuyerAppointmentCardProps {
  buyerAppointment: BuyerAppointments_buyerAppointments;
}

export const BuyerAppointmentCard: React.FC<IBuyerAppointmentCardProps> = ({
  buyerAppointment,
}) => {
  const date = moment(buyerAppointment.scheduledTime).format('l');
  const time = moment(buyerAppointment.scheduledTime).format('LT');

  return (
    <ContentCard forceBorder>
      <Row className="w-full items-baseline justify-between pb-2">
        <Col>
          <Text as="p" className="text-subheader-xs">
            {buyerAppointment.customer.fullName}
          </Text>
          <Text as="p" className="text-body-md">
            {buyerAppointment.customer.email}
            {buyerAppointment.customer.phoneNumber
              ? ` • ${formatPhoneNumberInput(buyerAppointment.customer.phoneNumber)}`
              : null}
          </Text>
        </Col>
        <StatusBadge
          status={getStatus(buyerAppointment.state)}
          color={STATUS_COLOR[buyerAppointment.state]}
        />
      </Row>
      <Row className="gap-4">
        <Item label="Date" value={date} />
        <Item label="Time" value={time} />
        <Item label="Address" value={buyerAppointment.readableAddress} />
      </Row>
    </ContentCard>
  );
};

interface IItemProps {
  label: string;
  value: string;
}

const Item: React.FC<IItemProps> = ({ label, value }) => {
  return (
    <Col className="min-w-20">
      <Text as="p" className="text-label-md">
        {label}
      </Text>
      <Text as="p" className="text-body-md">
        {value}
      </Text>
    </Col>
  );
};

function getStatus(state: TourRequestState) {
  return 'Tour ' + capitalCase(state.toString());
}

const STATUS_COLOR: { [K in TourRequestState]: BadgeColor } = {
  CANCELED: 'red',
  NO_SHOW: 'red',
  REQUESTED: 'green',
  SCHEDULED: 'green',
  COMPLETE: 'green',
};
